import { useState, useRef, type JSX, useEffect } from 'react';

import {
  checkEmpty,
  getStoreValue,
  Icon,
  MiniModal,
  Tooltip,
} from 'pixel-react';
import { useSelector } from 'react-redux';

import { RootState } from '@/store';
import type { Test_Optimize_ResponseObject } from '@/store/commonApiType/testOptimizeUserType';
import { useLazyGetUserProfileDetailsQuery } from '@/store/userProfile/userProfileSlice';

import styles from './Profile.module.scss';
import ProfileModal from './ProfileModal';

const Profile = (): JSX.Element => {
  const profileRef = useRef<HTMLButtonElement | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const username = getStoreValue(
    'test-optimize-user',
  ) as Test_Optimize_ResponseObject;
  const { id } = username?.responseObject ?? '';
  const [getUserProfileData] = useLazyGetUserProfileDetailsQuery();
  const profileData = useSelector(
    (state: RootState) => state.profileDataSlice.profileData,
  );
  const toggleModal = () => {
    setIsOpen(prev => !prev);
    if (!getStoreValue('test-optimize-user')) {
      window.location.href = '/signin';
    }
  };
  useEffect(() => {
    if (checkEmpty(profileData)) {
      getUserProfileData(id);
    }
  }, []);
  useEffect(() => {
    const { profileImage, profileImagePath } =
      profileData?.responseObject ?? '';
    if (profileImage) {
      if (profileImagePath?.includes('svg')) {
        setImagePreview(`data:image/svg+xml;base64,${profileImage}`);
      } else {
        setImagePreview(`data:image;base64,${profileImage}`);
      }
    } else {
      setImagePreview(null);
    }
  }, [profileData]);

  const handleOutsideClick = () => !isDrawerOpen && setIsOpen(false);

  return (
    <>
      <div
        className={
          imagePreview ? styles.profile_container : styles.user_icon_container
        }
      >
        <span ref={profileRef} onClick={toggleModal}>
          <Tooltip title="User Profile" placement="bottom-end">
            {imagePreview ? (
              <img
                src={imagePreview}
                alt="Profile Preview"
                className={styles.profile_container}
              />
            ) : (
              <Icon
                color="var(--brand-color)"
                name="user_profile"
                height={16}
                width={16}
                cursorType="pointer"
              />
            )}
          </Tooltip>
        </span>
      </div>

      {isOpen && getStoreValue('test-optimize-user') && (
        <MiniModal
          anchorRef={profileRef}
          outSideClick={handleOutsideClick}
          childContent={
            <ProfileModal
              setIsOpen={setIsOpen}
              setIsDrawerOpen={setIsDrawerOpen}
            />
          }
          modalProperties={{
            zIndex: isDrawerOpen ? 0 : 10000,
            right: 12,
            top: 45,
            width: 160,
          }}
          isIconModel={isOpen}
          firstAnchorRef={profileRef}
          anchorLeftDistanceForWrapper={129}
          extraTopSpace={{ normalModal: 5 }}
        />
      )}
    </>
  );
};

export default Profile;
